/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
    "account": "Konto",
    "active_date": "Aktivdatum",
    "address": "Adresse",
    "address2": "Adresse 2 (optional)",
    "amount": "Betrag",
    "and": "und",
    "article": "Artikel",
    "buy": "Einkauf",
    "buyer": "Käufer",
    "buyer_info": "Käuferinformationen",
    "cancel": "Abbrechen",
    "canceled": "Storniert",
    "cellphone": "Mobiltelefon",
    "certification_expires": "Nicht autorisiert oder abgelaufen, bitte erneut anmelden",
    "change_password": "Passwort ändern",
    "city": "Stadt",
    "clear": "Löschen",
    "commercial": "Kommerziell",
    "company": "Unternehmen",
    "completed": "Abgeschlossen",
    "confirm_password": "Passwort bestätigen",
    "contact": "Kontakt",
    "country": "Land",
    "create": "Erstellen",
    "create_account": "Konto erstellen",
    "create_date": "Erstellungsdatum",
    "creationdate": "Erstellungsdatum",
    "currency": "Währung",
    "customer_success": "Registrierung erfolgreich, bitte E-Mail prüfen und aktivieren",
    "dead_line": "Frist",
    "dealer": "Händler",
    "dealer_success": "Wartet auf Genehmigung",
    "description": "Beschreibung",
    "domain": "Domain",
    "domain_in_use": "Domain bereits verwendet",
    "email": "E-Mail",
    "email_format_error": "Ungültiges E-Mail-Format",
    "email_used": "E-Mail bereits verwendet",
    "enter_character": "Zeichen im Bild eingeben",
    "enter_confirm_password": "Neues Passwort erneut eingeben",
    "enter_new_password": "Neues Passwort eingeben",
    "enter_old_password": "Altes Passwort eingeben",
    "erp_list": "Abonnements",
    "erp_status": "Status",
    "expire_date": "Ablaufdatum",
    "female": "Weiblich",
    "first_name": "Vorname",
    "forget_password": "Passwort vergessen?",
    "forgot_password": "Passwort vergessen?",
    "form_not_exist": "Formular existiert nicht",
    "format_error": "Formatfehler",
    "group_code": "Gruppencode",
    "group_name": "Gruppenname",
    "home_company_address": "Privat-/Firmenadresse",
    "image": "Bild",
    "information_success": "Kontoinformation erfolgreich geändert",
    "initial_info": "Anfangsinformation",
    "input_password": "Passwort eingeben",
    "input_password_again": "Bitte Passwort erneut eingeben",
    "last_name": "Nachname",
    "legal_person": "Juristische Person",
    "male": "Männlich",
    "modify": "Ändern",
    "modify_erp_information": "ERP-Daten ändern",
    "modules": "Module",
    "month": "Benutzer/Monat",
    "name": "Name",
    "new_password": "Neues Passwort",
    "new_password_toEmail": "Neues Passwort wurde per E-Mail gesendet",
    "next": "Weiter",
    "noFoundurl": "Instanz existiert nicht",
    "not_null": "Pflichtfelder nicht ausgefüllt",
    "official_website": "Offizielle Website:",
    "ok": "OK",
    "old_password": "Altes Passwort",
    "old_password_error": "Altes Passwort stimmt nicht",
    "one_time_payment": "Einmalzahlung",
    "operation": "Vorgang",
    "or": "ODER",
    "order": "Auftrag",
    "order-no": "Auftragsnr",
    "order_close": "Auftrag geschlossen",
    "order_list": "Auftragsliste",
    "order_no": "Auftragsnr.",
    "order_status": "Auftragsstatus",
    "other": "Sonstiges",
    "paid": "Bezahlt",
    "password": "Passwort",
    "password_error": "Passwort muss 6-20 Zeichen (Buchstaben und Zahlen) enthalten",
    "password_error_two": "Passwörter stimmen nicht überein",
    "password_least": "Passwort mind. 6 Zeichen mit Zahlen und Buchstaben/Sonderzeichen",
    "password_strength": "Passwortstärke",
    "pay": "Einkauf",
    "pay_error": "Zahlungsdaten konnten nicht geladen werden",
    "payment": "Zahlungsmethode",
    "payment_date": "Zahlungsdatum",
    "personal": "Persönlich",
    "please_email": "Bitte E-Mail prüfen",
    "pos": "Pos.",
    "previous": "Zurück",
    "price": "Preis",
    "privacy": "Durch Erstellung eines SOMATIME-Kontos stimmen Sie zu",
    "privacy_notice": "Datenschutzerklärung",
    "product": "Produkte",
    "product_list": "Produktliste",
    "product_name": "Produktname",
    "purchase": "Einkauf",
    "purchase_success": "Kauf erfolgreich",
    "refunded": "Erstattet",
    "registered": "E-Mail bereits registriert",
    "registered_email_address": "Registrierung mit Ihrer E-Mail erfolgt",
    "renewal": "Verlängerung",
    "repeat_password": "Passwort wiederholen",
    "requied": "Erforderlich",
    "requied_num": "Nur Zahlen",
    "require_tips": "Käuferdaten fehlen",
    "required": "Erforderlich",
    "reseller": "Wiederverkäufer",
    "resend": "Erneut senden",
    "reset_password": "E-Mail mit Passwortbestätigungslink gesendet an",
    "revoke": "Auftrag stornieren",
    "revoke_tip1": "Aktuellen Auftrag schließen?",
    "role": "Rolle",
    "search": "Suchen",
    "send_update": "Updates von SOMATIME senden",
    "sex": "Geschlecht",
    "signIn": "Anmelden",
    "sign_out": "Abmelden",
    "state": "Bundesland/Provinz",
    "status": "Zahlungsstatus",
    "status_not_match": "Status stimmt nicht überein",
    "strength_high": "Hoch",
    "strength_low": "Niedrig",
    "strength_mid": "Mitte",
    "submit": "Senden",
    "submitted": "Gesendet",
    "subscribe": "Abonnieren",
    "subscribe-mon": "Abo-Monat",
    "subscript_success": "Abo erfolgreich",
    "telephone": "Telefon",
    "tenant_list": "Mandantenliste",
    "tenant_management_system": "Mandantenverwaltungssystem",
    "tenant_system": "Mandantensystem",
    "terms_of_use": "Nutzungsbedingungen",
    "time_info": "Zeitinfo",
    "title": "Titel",
    "unpaid": "Unbezahlt",
    "update_password_success": "Passwort erfolgreich geändert",
    "user": "Benutzer",
    "user_check": "Bitte Datenschutz und Nutzungsbedingungen lesen und akzeptieren",
    "user_id": "Benutzer-ID",
    "user_month": "Monat",
    "user_not_active": "Benutzer nicht aktiviert",
    "user_not_exist": "Benutzer existiert nicht",
    "user_password_error": "Falsches Passwort",
    "user_qty": "Benutzeranzahl",
    "username": "Benutzername",
    "ver_code_error": "Verifizierungscode falsch",
    "ver_code_exd": "Verifizierungscode abgelaufen",
    "visit": "Besuchen",
    "welcome_to_iceq": "WILLKOMMEN BEI SOMATIME",
    "zip": "PLZ",
    "trial": "Testversion",
    "requesting_a_trial": "Antrag erfolgreich! Demo-Infos innerhalb von 24 Std.",
    "trial_orders_have_been_requested": "Testbestellung angefordert",
    "apply_trial": "Demo anfordern",
    "request_": "Anfrage",
    "trial_": "Testversion",
    "on_trial": "In Testphase",
    "order_not_exist": "Auftrag existiert nicht",
    "wait_for_payment": "Warten auf Zahlung",
    "trial_reject": "Demo abgelehnt",
    "tips": "Tipps",
    "confirm": "Bestätigen",
    "cancel": "Abbrechen",
    "trial_only_allow_one_time_payment_method": "Test nur Einmalzahlung möglich",
    "domain_info": "Domaininfo",
    "please_fill_in_domain_info": "Domaininfo eingeben",
    "user_quantity_and_month_required": "Benutzeranzahl & Monat erforderlich",
    "password_must_be_the_same": "Bestätigung muss übereinstimmen",
    "enter_the_password_and_new_password": "Passwort & neues eingeben",
    "wrong_user_name_and_password": "Benutzer/Passwort falsch",
    "close_the_page_without_saving": "Ohne Speichern schließen?",
    "cancel_input": "Eingabe abbrechen",
    "user_does_not_exist": "Benutzer existiert nicht",
    "modify_success": "Änderung erfolgreich",
    "email_has_been_used": "E-Mail bereits verwendet",
    "created_successfully": "Erfolgreich erstellt",
    "error_tip_10098": "E-Mail fehlgeschlagen, Admin kontaktieren",
};